import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { BudgetFilter } from '../../../models/budgets/budget.filter';

@Component({
	selector: 'budget-filter',
	templateUrl: './budget-filter.component.html',
	styleUrls: ['./budget-filter.component.css']
})
export class BudgetFilterComponent implements OnInit {

	showFilter: boolean = false;
	
	@Input() filter: BudgetFilter = new BudgetFilter();
	@Output() search: EventEmitter<BudgetFilter> = new EventEmitter<BudgetFilter>()
	
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showFilter = false;
	}

	constructor(private _elementRef: ElementRef,) { }

	ngOnInit() {
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	onSearchClick() {
		this.search.emit(this.filter);
		this.showFilter = false;
	}

	onClearClick() {
		this.filter.dateRecieved = null;
		this.filter.recieverId = null;
		this.filter.releasedById = null;
		this.filter.createdDate = null; //date filed
		this.filter.createdBy = null;
		this.filter.updatedDate = null;
		this.filter.updatedBy = null;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/budgets/budget-filter/budget-filter.component.ts